import type {FC} from 'react';
import {Helmet} from 'react-helmet-async';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import {tokens} from '../../locales/tokens';

interface PwmSeoProps {
  title?: string;
}

export const PwmSeo: FC<PwmSeoProps> = (props) => {
  const {title} = props;
  const {t} = useTranslation();
  const fullTitle = title || `${t(tokens.nav.pwm)}`;

  return (
    <Helmet>
      <title>
        {fullTitle}
      </title>
    </Helmet>
  );
};

PwmSeo.propTypes = {
  title: PropTypes.string
};
